import { render, staticRenderFns } from "./nodata.vue?vue&type=template&id=52de546e&scoped=true&"
import script from "./nodata.vue?vue&type=script&lang=ts&"
export * from "./nodata.vue?vue&type=script&lang=ts&"
import style0 from "./nodata.vue?vue&type=style&index=0&id=52de546e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52de546e",
  null
  
)

export default component.exports